import { render } from "./SchemeEditor.vue?vue&type=template&id=f0fdd5f2&scoped=true"
import script from "./SchemeEditor.vue?vue&type=script&lang=js"
export * from "./SchemeEditor.vue?vue&type=script&lang=js"

import "./SchemeEditor.vue?vue&type=style&index=0&id=f0fdd5f2&scoped=true&lang=css"
import "./SchemeEditor.vue?vue&type=style&index=1&id=f0fdd5f2&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fdd5f2"]])

export default __exports__